import type { AnalyticsPageRow } from "@/lib/api";
import { cn } from "@/lib/formatters";

interface TopPagesTableProps {
  rows: AnalyticsPageRow[];
  limit?: number;
}

function posColor(pos: number): string {
  if (pos <= 10) return "text-success";
  if (pos <= 20) return "text-primary";
  if (pos <= 30) return "text-warn";
  return "text-muted";
}

function shortPath(url: string): string {
  return url.replace(/^https?:\/\/[^/]+/, "") || "/";
}

export function TopPagesTable({ rows, limit = 10 }: TopPagesTableProps) {
  const shown = rows.slice(0, limit);

  return (
    <div className="surface overflow-hidden">
      <div className="px-4 py-3 border-b border-border flex items-center justify-between">
        <p className="path-chip">top pages</p>
        <span className="font-mono text-xs text-muted">
          {shown.length}/{rows.length}
        </span>
      </div>
      {shown.length === 0 ? (
        <p className="p-6 text-center font-mono text-sm text-muted">$ no pages</p>
      ) : (
        <table className="w-full text-sm">
          <thead className="bg-bg-elev/40 border-b border-border">
            <tr className="text-left text-xs font-mono uppercase tracking-wider text-muted">
              <th className="px-3 py-2">path</th>
              <th className="px-2 py-2 text-right">clk</th>
              <th className="px-2 py-2 text-right">imp</th>
              <th className="px-2 py-2 text-right">pos</th>
            </tr>
          </thead>
          <tbody>
            {shown.map((r) => {
              const path = shortPath(r.page);
              return (
                <tr
                  key={r.page}
                  className="border-b border-border/40 last:border-0 hover:bg-bg-elev/30 transition-colors"
                >
                  <td className="px-3 py-2 truncate max-w-[220px] font-mono text-xs" title={path}>
                    {path}
                  </td>
                  <td className="px-2 py-2 text-right font-mono">{r.clicks}</td>
                  <td className="px-2 py-2 text-right font-mono text-muted">{r.impressions}</td>
                  <td className={cn("px-2 py-2 text-right font-mono", posColor(r.position))}>
                    {r.position.toFixed(1)}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
}
